export const MAX_CONTRACT_BYTES = 10 * 1024 * 1024;
export function contractFileError(file) {
  if (!file || !file.name?.toLowerCase().endsWith('.pdf') || (file.type && file.type !== 'application/pdf')) return 'Please select a PDF file.';
  if (!file.size || file.size > MAX_CONTRACT_BYTES) return 'Select a non-empty PDF no larger than 10 MB.';
  return null;
}
